export default __webpack_public_path__ + "static/media/group-3@3x.eb2fd2d9.png";